

























import {Vue, Component} from 'vue-property-decorator';
import Carousel from 'primevue/carousel';
import Button from 'primevue/button';

/**
 * Class-component
 */
@Component({
    components: {
        Carousel: Vue.extend(Carousel),
        Button: Vue.extend(Button),
    }
})
export default class Home extends Vue {
    link(url) {
        window.location = url
    }
    products = [
        {
            "name": "Report Online Storage",
            "description": "Product Description",
            "url": 'https://edt.dita1.fhk-app.com/',
        },
        {
            "name": "Qualification/Training Databank",
            "description": "Product Description",
            "url": 'https://cvt.dita1.fhk-app.com/',
        },            {
            "name": "Project Folders",
            "description": "Product Description",
            "url": 'https://pft.dita1.fhk-app.com/',
        },
    ]
}
